import { Typography } from "@packages/ds";
import styled from "styled-components";

export const Wrapper = styled.header`
  display: flex;
  margin-bottom: 24px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled(Typography.Title)`
  margin: 0 16px 0 0;
`;

export const Flex = styled.div`
  display: flex;
  align-items: center;

  svg {
    margin-right: 16px;
  }
`;
